import { GameRoundDto, Pagination } from "interfaces/interfaces";
import { useEffect } from "react";
import useSWR from "swr";
import _ from "lodash";
import { useSearchParams } from "react-router-dom";
import { swrSingleGetConfig } from "configs/swrConfig";
import { useAppContext } from "./useAppContext";

const useHistory = () => {
  const context = useAppContext();
  const [searchParams] = useSearchParams();

  const fetcher = async (url: string) => {
    const queryParams = new URLSearchParams({
      Token: searchParams.get("token") as string,
    });
    const response = await fetch(`${url}?${queryParams}`, {
      method: "GET",
    });

    return await response.json();
  };

  const { data, isValidating, mutate } = useSWR<Pagination<GameRoundDto>>(`${process.env.REACT_APP_API_URL}/game/history`, fetcher, swrSingleGetConfig);

  useEffect(() => {
    mutate();
  }, []);

  useEffect(() => {
    context.setHistory(data?.items as GameRoundDto[]);
  }, [data]);

  return { context, isValidating };
};

export default useHistory;
